import axios from '@/plugins/axios'
import { urlUploadFiles } from '@/utils/urls'
import Pagination from '@/plugins/best-modules/components/Pagination.vue'
import { createBestModules } from 'best-modules/plugin'
import SidebarListItem from '@/plugins/best-modules/components/SidebarListItem.vue'
import ServerFilter from './components/server-filter/ServerFilter.vue'

export default createBestModules({
  axios,
  urls: {
    urlUploadFiles: urlUploadFiles,
  },
  requestConfig: {
    rejectHandler: e => e,
  },
  templates: {
    BServerFilter: {
      component: ServerFilter,
    },
    BPagination: {
      component: Pagination,
    },
    BInputDate: {
      modelValueFormat: 'iso',
    },
    BSidebarMenu: {
      ListItem: {
        component: SidebarListItem,
      },
    },
  },
})
